import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-bc5b1d68"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "l-footer" }
const _hoisted_2 = { class: "l-footer__list" }
const _hoisted_3 = ["href"]
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<li class=\"l-footer__item\" data-v-bc5b1d68><a href=\"\" data-v-bc5b1d68>運営会社</a></li><li class=\"l-footer__item\" data-v-bc5b1d68><a href=\"\" data-v-bc5b1d68>サイトマップ</a></li><li class=\"l-footer__item\" data-v-bc5b1d68><a href=\"\" data-v-bc5b1d68>サイトポリシー</a></li><li class=\"l-footer__item\" data-v-bc5b1d68><a href=\"\" data-v-bc5b1d68>プライバシーポリシー</a></li><li class=\"l-footer__item\" data-v-bc5b1d68><a href=\"\" data-v-bc5b1d68>お問い合わせ</a></li>", 5)
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "© 2024 THE POWER NEWS / All rights reserved.", -1))


export default /*#__PURE__*/_defineComponent({
  __name: 'MainFooter',
  setup(__props) {

const endpointWp = process.env.VUE_APP_ENDPOINT_WP || '#';

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("ul", _hoisted_2, [
      _createElementVNode("li", null, [
        _createElementVNode("a", {
          href: `${_unref(endpointWp)}/`
        }, "トップ", 8, _hoisted_3)
      ]),
      _hoisted_4
    ]),
    _hoisted_9
  ]))
}
}

})